export enum AvailableInterchangeOutStatus {
    Unknown = 'Unknown',
    Valid = 'Valid',
    MissingInstances = 'MissingInstances',
    FileUnavailable = 'FileUnavailable'
}
